<template>
  <div class="form-edit-page">
    <div class="page-header">
      <div>
        <h2>Cadastro de Informações Ambientais</h2>
        <p class="page-subtitle">
          Controle dos aspectos ambientais do estabelecimento e histórico de acompanhamentos.
        </p>
      </div>
    </div>

    <!-- FORMULÁRIO PRINCIPAL -->
    <div class="form-card">
      <div class="form-card-header">
        <h3>Dados Ambientais do Estabelecimento</h3>
      </div>

      <div class="form-body">
        <div class="row">
          <div class="field col-4">
            <label>Estabelecimento</label>
            <select v-model="formAmbiental.idEstabelecimento">
              <option :value="null">Selecione...</option>
              <option
                v-for="item in estabelecimentos"
                :key="item.id"
                :value="item.id"
              >
                {{ item.nome }}
              </option>
            </select>
          </div>

          <div class="field col-2">
            <label>Situação ambiental</label>
            <select v-model="formAmbiental.situacaoAmbiental">
              <option value="REGULAR">Regular</option>
              <option value="ATENCAO">Atenção</option>
              <option value="PENDENTE">Pendente</option>
            </select>
          </div>

          <div class="field col-3">
            <label>Responsável pelas informações</label>
            <input
              v-model="formAmbiental.responsavelInformacoes"
              type="text"
              placeholder="Nome do responsável"
            />
          </div>

          <div class="field col-3">
            <label>Periodicidade de monitoramento</label>
            <select v-model="formAmbiental.periodicidadeMonitoramento">
              <option value="">Selecione...</option>
              <option value="SEMANAL">Semanal</option>
              <option value="QUINZENAL">Quinzenal</option>
              <option value="MENSAL">Mensal</option>
              <option value="BIMESTRAL">Bimestral</option>
              <option value="TRIMESTRAL">Trimestral</option>
              <option value="SEMESTRAL">Semestral</option>
              <option value="ANUAL">Anual</option>
            </select>
          </div>
        </div>

        <div class="section-title">Abastecimento de Água</div>

        <div class="row">
          <div class="field col-3">
            <label>Fonte de abastecimento</label>
            <select v-model="formAmbiental.fonteAgua">
              <option value="">Selecione...</option>
              <option value="REDE_PUBLICA">Rede pública</option>
              <option value="POCO_ARTESIANO">Poço artesiano</option>
              <option value="NASCENTE">Nascente</option>
              <option value="MISTA">Mista</option>
              <option value="OUTRA">Outra</option>
            </select>
          </div>

          <div class="field col-2">
            <label>Possui reservatório?</label>
            <select v-model="formAmbiental.possuiReservatorio">
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>

          <div class="field col-2">
            <label>Controle de potabilidade?</label>
            <select v-model="formAmbiental.controlePotabilidade">
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>

          <div class="field col-2">
            <label>Cloração</label>
            <select v-model="formAmbiental.cloracao">
              <option value="SIM">Sim</option>
              <option value="NAO">Não</option>
              <option value="NAO_APLICAVEL">Não aplicável</option>
            </select>
          </div>

          <div class="field col-3">
            <label>Observações da água</label>
            <input
              v-model="formAmbiental.obsAgua"
              type="text"
              placeholder="Resumo das condições"
            />
          </div>
        </div>

        <div class="section-title">Resíduos</div>

        <div class="row">
          <div class="field col-3">
            <label>Destinação dos resíduos sólidos</label>
            <select v-model="formAmbiental.destinacaoResiduos">
              <option value="">Selecione...</option>
              <option value="COLETA_PUBLICA">Coleta pública</option>
              <option value="EMPRESA_TERCEIRIZADA">Empresa terceirizada</option>
              <option value="TRATAMENTO_PROPRIO">Tratamento próprio</option>
              <option value="MISTA">Mista</option>
            </select>
          </div>

          <div class="field col-2">
            <label>Segregação de resíduos?</label>
            <select v-model="formAmbiental.segregacaoResiduos">
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>

          <div class="field col-3">
            <label>Empresa coletora</label>
            <input
              v-model="formAmbiental.empresaColetora"
              type="text"
              placeholder="Nome da empresa"
            />
          </div>

          <div class="field col-4">
            <label>Observações dos resíduos</label>
            <input
              v-model="formAmbiental.obsResiduos"
              type="text"
              placeholder="Informações complementares"
            />
          </div>
        </div>

        <div class="section-title">Efluentes</div>

        <div class="row">
          <div class="field col-3">
            <label>Destinação dos efluentes</label>
            <select v-model="formAmbiental.destinacaoEfluentes">
              <option value="">Selecione...</option>
              <option value="REDE_PUBLICA">Rede pública</option>
              <option value="SISTEMA_PROPRIO">Sistema próprio</option>
              <option value="FOSSA_FILTRO">Fossa / filtro</option>
              <option value="OUTRO">Outro</option>
            </select>
          </div>

          <div class="field col-2">
            <label>Possui tratamento?</label>
            <select v-model="formAmbiental.tratamentoEfluentes">
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>

          <div class="field col-3">
            <label>Tipo de tratamento</label>
            <input
              v-model="formAmbiental.tipoTratamento"
              type="text"
              placeholder="Ex.: decantação, filtro, etc."
            />
          </div>

          <div class="field col-4">
            <label>Observações dos efluentes</label>
            <input
              v-model="formAmbiental.obsEfluentes"
              type="text"
              placeholder="Informações complementares"
            />
          </div>
        </div>

        <div class="row">
          <div class="field col-12">
            <label>Observações gerais</label>
            <textarea
              v-model="formAmbiental.observacoesGerais"
              rows="4"
              placeholder="Observações gerais sobre a situação ambiental do estabelecimento"
            ></textarea>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn btn-primary" @click="salvarDadosAmbientais">
            Salvar dados ambientais
          </button>
          <button class="btn btn-secondary" @click="carregarExemplo">
            Carregar exemplo
          </button>
          <button class="btn btn-light" @click="limparDadosAmbientais">
            Limpar
          </button>
        </div>
      </div>
    </div>

    <!-- HISTÓRICO -->
    <div class="form-card">
      <div class="form-card-header between">
        <h3>{{ editandoHistorico ? 'Editar registro ambiental' : 'Novo registro de acompanhamento' }}</h3>
      </div>

      <div class="form-body">
        <div class="row">
          <div class="field col-2">
            <label>Data do registro</label>
            <input v-model="formHistorico.dataRegistro" type="date" />
          </div>

          <div class="field col-3">
            <label>Tipo de controle</label>
            <select v-model="formHistorico.tipoControle">
              <option value="">Selecione...</option>
              <option value="AGUA">Água</option>
              <option value="RESIDUOS">Resíduos</option>
              <option value="EFLUENTES">Efluentes</option>
              <option value="LIMPEZA_AMBIENTAL">Limpeza ambiental</option>
              <option value="COLETA_TERCEIRIZADA">Coleta terceirizada</option>
              <option value="OUTRO">Outro</option>
            </select>
          </div>

          <div class="field col-3">
            <label>Parâmetro / item avaliado</label>
            <input
              v-model="formHistorico.parametro"
              type="text"
              placeholder="Ex.: potabilidade, segregação, destinação..."
            />
          </div>

          <div class="field col-2">
            <label>Resultado</label>
            <select v-model="formHistorico.resultado">
              <option value="">Selecione...</option>
              <option value="CONFORME">Conforme</option>
              <option value="NAO_CONFORME">Não conforme</option>
              <option value="PENDENTE">Pendente</option>
            </select>
          </div>

          <div class="field col-2">
            <label>Responsável</label>
            <input
              v-model="formHistorico.responsavel"
              type="text"
              placeholder="Responsável"
            />
          </div>
        </div>

        <div class="row">
          <div class="field col-12">
            <label>Observações</label>
            <textarea
              v-model="formHistorico.observacoes"
              rows="3"
              placeholder="Detalhes do registro, medições, pendências, providências, etc."
            ></textarea>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn btn-primary" @click="salvarHistorico">
            {{ editandoHistorico ? 'Atualizar registro' : 'Adicionar registro' }}
          </button>

          <button
            v-if="editandoHistorico"
            class="btn btn-secondary"
            @click="cancelarEdicaoHistorico"
          >
            Cancelar edição
          </button>
        </div>
      </div>
    </div>

    <!-- LISTA DE HISTÓRICO -->
    <div class="list-card">
      <div class="list-card-header">
        <h3>Histórico de Controles / Medições</h3>
      </div>

      <div class="table-responsive">
        <table class="data-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Tipo</th>
              <th>Parâmetro</th>
              <th>Resultado</th>
              <th>Responsável</th>
              <th>Observações</th>
              <th style="width: 150px;">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="historico.length === 0">
              <td colspan="7" class="empty-state">
                Nenhum registro ambiental informado.
              </td>
            </tr>

            <tr v-for="item in historico" :key="item.id">
              <td>{{ formatarData(item.dataRegistro) }}</td>
              <td>{{ formatarTipoControle(item.tipoControle) }}</td>
              <td>{{ item.parametro || '-' }}</td>
              <td>
                <span class="status-badge" :class="resultadoClass(item.resultado)">
                  {{ formatarResultado(item.resultado) }}
                </span>
              </td>
              <td>{{ item.responsavel || '-' }}</td>
              <td>{{ item.observacoes || '-' }}</td>
              <td>
                <div class="table-actions">
                  <button class="btn-action" @click="editarHistorico(item)">Editar</button>
                  <button class="btn-action danger" @click="excluirHistorico(item.id)">Excluir</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- RESUMO -->
    <div class="info-card">
      <h3>Conceito para a implantação oficial</h3>
      <p>
        Este cadastro pode ser usado para registrar as condições ambientais permanentes do estabelecimento
        e manter o histórico de acompanhamentos realizados pelo serviço de inspeção.
      </p>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';

const estabelecimentos = ref([
  { id: 1, nome: 'Frigorífico Modelo Ltda' },
  { id: 2, nome: 'Laticínios Serra Alta' },
  { id: 3, nome: 'Entreposto Apícola Vale Verde' },
]);

const novoFormularioAmbiental = () => ({
  idEstabelecimento: 1,
  situacaoAmbiental: 'REGULAR',
  responsavelInformacoes: 'Carlos Mendes',
  periodicidadeMonitoramento: 'MENSAL',
  fonteAgua: 'REDE_PUBLICA',
  possuiReservatorio: true,
  controlePotabilidade: true,
  cloracao: 'SIM',
  obsAgua: 'Abastecimento regular com controle interno.',
  destinacaoResiduos: 'EMPRESA_TERCEIRIZADA',
  segregacaoResiduos: true,
  empresaColetora: 'Ambiental Coletas Ltda',
  obsResiduos: 'Coleta periódica com segregação por tipo.',
  destinacaoEfluentes: 'SISTEMA_PROPRIO',
  tratamentoEfluentes: true,
  tipoTratamento: 'Sistema próprio com caixa de retenção',
  obsEfluentes: 'Sistema em operação regular.',
  observacoesGerais: 'Estabelecimento apresenta rotina ambiental organizada e monitorada.',
});

const novoHistorico = () => ({
  id: null,
  dataRegistro: '',
  tipoControle: '',
  parametro: '',
  resultado: '',
  responsavel: '',
  observacoes: '',
});

const formAmbiental = reactive(novoFormularioAmbiental());
const formHistorico = reactive(novoHistorico());

const editandoHistorico = ref(false);
const proximoIdHistorico = ref(4);

const historico = ref([
  {
    id: 1,
    dataRegistro: '2026-03-10',
    tipoControle: 'AGUA',
    parametro: 'Controle de potabilidade',
    resultado: 'CONFORME',
    responsavel: 'Supervisor SIM',
    observacoes: 'Registro apresentado e dentro da rotina prevista.',
  },
  {
    id: 2,
    dataRegistro: '2026-03-05',
    tipoControle: 'EFLUENTES',
    parametro: 'Destinação e tratamento',
    resultado: 'CONFORME',
    responsavel: 'Inspetor',
    observacoes: 'Sistema funcionando adequadamente.',
  },
  {
    id: 3,
    dataRegistro: '2026-03-01',
    tipoControle: 'RESIDUOS',
    parametro: 'Comprovante de coleta terceirizada',
    resultado: 'PENDENTE',
    responsavel: 'Supervisor SIM',
    observacoes: 'Solicitado comprovante atualizado da empresa coletora.',
  },
]);

function salvarDadosAmbientais() {
  if (!formAmbiental.idEstabelecimento) {
    alert('Selecione o estabelecimento.');
    return;
  }

  alert('Dados ambientais salvos no modo demonstração.');
}

function limparDadosAmbientais() {
  Object.assign(formAmbiental, {
    idEstabelecimento: null,
    situacaoAmbiental: 'REGULAR',
    responsavelInformacoes: '',
    periodicidadeMonitoramento: '',
    fonteAgua: '',
    possuiReservatorio: true,
    controlePotabilidade: true,
    cloracao: 'SIM',
    obsAgua: '',
    destinacaoResiduos: '',
    segregacaoResiduos: true,
    empresaColetora: '',
    obsResiduos: '',
    destinacaoEfluentes: '',
    tratamentoEfluentes: true,
    tipoTratamento: '',
    obsEfluentes: '',
    observacoesGerais: '',
  });
}

function carregarExemplo() {
  Object.assign(formAmbiental, novoFormularioAmbiental());
}

function salvarHistorico() {
  if (!formHistorico.dataRegistro || !formHistorico.tipoControle || !formHistorico.resultado) {
    alert('Informe data, tipo de controle e resultado.');
    return;
  }

  if (editandoHistorico.value) {
    const index = historico.value.findIndex(item => item.id === formHistorico.id);
    if (index >= 0) {
      historico.value[index] = { ...formHistorico };
    }
  } else {
    historico.value.unshift({
      ...formHistorico,
      id: proximoIdHistorico.value++,
    });
  }

  limparHistorico();
}

function editarHistorico(item) {
  Object.assign(formHistorico, { ...item });
  editandoHistorico.value = true;
}

function cancelarEdicaoHistorico() {
  limparHistorico();
}

function excluirHistorico(id) {
  const ok = window.confirm('Deseja excluir este registro do histórico?');
  if (!ok) return;

  historico.value = historico.value.filter(item => item.id !== id);

  if (formHistorico.id === id) {
    limparHistorico();
  }
}

function limparHistorico() {
  Object.assign(formHistorico, novoHistorico());
  editandoHistorico.value = false;
}

function formatarData(data) {
  if (!data) return '-';
  const [ano, mes, dia] = data.split('-');
  if (!ano || !mes || !dia) return data;
  return `${dia}/${mes}/${ano}`;
}

function formatarTipoControle(tipo) {
  const mapa = {
    AGUA: 'Água',
    RESIDUOS: 'Resíduos',
    EFLUENTES: 'Efluentes',
    LIMPEZA_AMBIENTAL: 'Limpeza ambiental',
    COLETA_TERCEIRIZADA: 'Coleta terceirizada',
    OUTRO: 'Outro',
  };
  return mapa[tipo] || tipo || '-';
}

function formatarResultado(resultado) {
  const mapa = {
    CONFORME: 'Conforme',
    NAO_CONFORME: 'Não conforme',
    PENDENTE: 'Pendente',
  };
  return mapa[resultado] || resultado || '-';
}

function resultadoClass(resultado) {
  return {
    'badge-success': resultado === 'CONFORME',
    'badge-danger': resultado === 'NAO_CONFORME',
    'badge-warning': resultado === 'PENDENTE',
  };
}
</script>

<style scoped>
.form-edit-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: #f7f8fa;
}

.page-header h2 {
  margin: 0;
  font-size: 22px;
  color: #1f2937;
}

.page-subtitle {
  margin: 4px 0 0;
  color: #6b7280;
}

.form-card,
.list-card,
.info-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.form-card-header,
.list-card-header {
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.form-card-header h3,
.list-card-header h3,
.info-card h3 {
  margin: 0;
  font-size: 16px;
  color: #111827;
}

.form-card-header.between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.form-body {
  padding: 16px;
}

.section-title {
  margin: 6px 0 12px;
  padding: 8px 10px;
  background: #f3f4f6;
  border-left: 4px solid #2563eb;
  border-radius: 6px;
  font-weight: 700;
  color: #1f2937;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.field input,
.field select,
.field textarea {
  width: 100%;
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  background: #fff;
}

.field textarea {
  min-height: 90px;
  resize: vertical;
}

.field input:focus,
.field select:focus,
.field textarea:focus {
  border-color: #2563eb;
}

.col-12 { flex: 0 0 calc(100% - 0px); }
.col-4  { flex: 0 0 calc(33.333% - 8px); }
.col-3  { flex: 0 0 calc(25% - 9px); }
.col-2  { flex: 0 0 calc(16.666% - 10px); }

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.btn {
  border: none;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary {
  background: #2563eb;
  color: white;
}

.btn-secondary {
  background: #e5e7eb;
  color: #111827;
}

.btn-light {
  background: #f9fafb;
  color: #374151;
  border: 1px solid #d1d5db;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
  font-size: 14px;
  vertical-align: top;
}

.data-table thead th {
  background: #f9fafb;
  color: #374151;
  font-weight: 700;
}

.empty-state {
  text-align: center;
  color: #6b7280;
  padding: 24px !important;
}

.table-actions {
  display: flex;
  gap: 8px;
}

.btn-action {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 13px;
}

.btn-action.danger {
  color: #b91c1c;
  border-color: #fecaca;
  background: #fff5f5;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.badge-success {
  background: #dcfce7;
  color: #166534;
}

.badge-warning {
  background: #fef3c7;
  color: #92400e;
}

.badge-danger {
  background: #fee2e2;
  color: #991b1b;
}

.info-card {
  padding: 16px;
}

.info-card p {
  margin: 8px 0 0;
  color: #4b5563;
  line-height: 1.5;
}

@media (max-width: 1100px) {
  .col-4,
  .col-3,
  .col-2 {
    flex: 0 0 calc(50% - 6px);
  }
}

@media (max-width: 700px) {
  .col-4,
  .col-3,
  .col-2,
  .col-12 {
    flex: 0 0 100%;
  }
}
</style>